/// <reference path="Assistant.ts" />

namespace TerminalApp {


    export class OrderNoteForm extends Assistant {
        bc_menu = document.createElement("div");
        submit_button: HTMLElement;

        callback: (order: string) => void;

        current: SP.OrderInfo;

        orderNoteTextarea: HTMLTextAreaElement;

        constructor() {
            super();

            this.initialize();

            this.submit_button = this.bc_menu.querySelector(".btn");
            this.submit_button.addEventListener("click", async () => {
                SP.Sounds.Click.play();

                var postData = {
                    id: this.current.orderId,
                    note: this.orderNoteTextarea.value
                };

                let result = await SP.post<any>("/api/v1/order/update", postData);

                if (result.status == 200) {
                    this.current.note = postData.note;
                }
                else {
                    await SP.alertX("Error: " + result.status);
                }

                this.callback(this.current.note);

                this.close();
            });

        }

        open_bc() {
            this.container.style.display = "block";
            this.bc_menu.style.display = "block";
        }

        async open(order: SP.OrderInfo, callback: (order: string) => void) {
            this.clear();

            this.callback = callback;
            this.current = order;

            this.orderNoteTextarea.value = order.note;

            this.open_bc();
        }

        close() {
            this.clear();
            super.close();
        }

        clear() {
            this.current = null;
            this.orderNoteTextarea.value = "";
        }

        initialize() {

            this.bc_menu.innerHTML = `
                <div class="order-info-orderNote-overall-container">
                    <h1>${SP.Localize("sentance_edit_order_note")}</h1>
                    <textarea class="order-info-orderNote-textarea order-info-textarea" style="pointer-events: all;"></textarea>
                </div>

                <div class="btn noselect grad-green"><span class="action">${SP.Localize("word_save")}</span></div>
            `;

            this.orderNoteTextarea = this.bc_menu.querySelector(".order-info-textarea");

            this.container.appendChild(this.bc_menu);
        }

    }
}